#import "../../../../../graphql/fragments/peep-tag-maps-fragment.graphql"
#import "../../../../../graphql/fragments/creator-user-fragment.graphql"

fragment AccountSummaryFragment on Account {
    id
    employeeCount
    revenue {
        currencyValue {
            amount
        }
    }
    territory {
        id
        name
    }
    industry {
        id
        name
    }
    accountType {
        id
        name
    }
    createdTime
    creatorUser {
        ...CreatorUserFragment
    }
    owner {
        id
    }
    ...PeepTagMapsFragment
}
